enum YesNoSecurity {
  no = 0,
  yes = 1,
}

export default YesNoSecurity;
